export default __webpack_public_path__ + "assets/images/icon-default-avatar.2529befcfff46b6e5db66869b9e112e1.svg";